import OrigianlJoi from "joi";
import { ObjectSchema } from "joi";

type ObjectIdSchema = OrigianlJoi.AnySchema;

export interface ExtendedJoi extends OrigianlJoi.Root {
	objectId(): ObjectIdSchema;
}

const Joi: ExtendedJoi = OrigianlJoi.extend({
	type: "objectId",
	messages: {
		"objectId.base":
			"needs to be a string of 12 bytes or a string of 24 hex characters",
	},
	validate(value, helpers) {
		return {
			value,
			errors: null,
		};
	},
})
	.extend({
		type: "object",
		base: OrigianlJoi.object(),
		coerce: {
			from: "string",
			method(value, helpers) {
				if (value[0] !== "{" && !/^\s*\{/.test(value)) {
					return;
				}

				try {
					return { value: JSON.parse(value) };
				} catch (ignoreErr) {}
			},
		},
	})
	.extend({
		type: "array",
		base: OrigianlJoi.array(),
		coerce: {
			from: "string",
			method(value, helpers) {
				if (
					typeof value !== "string" ||
					(value[0] !== "[" && !/^\s*\[/.test(value))
				) {
					return;
				}

				try {
					return { value: JSON.parse(value) };
				} catch (ignoreErr) {}
			},
		},
	});

export type JoiSchema = OrigianlJoi.Schema;

export default Joi;

export function getJoiObjectKeys<T extends ObjectSchema>(schema: T): string[] {
	if (
		typeof schema.$_terms === "object" &&
		typeof schema.$_terms.keys === "object"
	) {
		return schema.$_terms.keys.map(e => e.key); // for Joi >= 16
	}
	return (schema as any)._inner.children.map(e => e.key); // For Joi <= 15
}
